<template>
  <div class='categories-training-component'>
    <div class='categories-details' @scroll='setActiveOnScroll'>
      <div class='categories-detail' v-for='(training, index) in trainings' :key='index' @click='onCategoryClick($event, training.name)' :class='{isActive: activeTrainingName == training.name}'>
        <div class='categories-container'>
          <img class='categories-logo' :src='training.logo'/>
          <div class="spacer"/>
          <div class='categories-name'>{{ training.name.toUpperCase() }}</div>
        </div>
        <div class='triangle-container' :class="{open: activeTrainingName == training.name}"></div>
      </div>
      <div class="fake-categorie"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CategoriesTrainingComponent',
  props: ['trainings', 'activeTrainingName'],

  mounted () {
    const container = document.querySelector('.categories-details')
    const element = document.querySelector('.categories-detail.isActive')
    const widthElement = element.getBoundingClientRect()

    container.scrollLeft = widthElement.left
  },

  methods: {
    onCategoryClick (event, trainingName) {
      const card = event.currentTarget
      if (card && typeof card.scrollIntoView === 'function') {
        card.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' })
      }
      this.openDescription(trainingName)
    },
    openDescription (trainingName) {
      if (this.$route.params.trainingName === trainingName) return
      this.$router.push({ name: 'TrainingPage', params: { trainingName: trainingName, mode: 'description' } })
    },
    setActiveOnScroll () {
      const container = document.querySelector('.categories-details')
      const element = document.querySelector('.categories-detail')
      const widthElement = (element.getBoundingClientRect()).width

      const index = (container.scrollLeft - 4) / (widthElement + 20)
      this.openDescription(this.trainings[Math.round(index)].name)
    }
  }
}
</script>

<style lang='scss' scoped>
.categories-training-component {
  width: 100%;

  @include media(tablet) {
    margin-top: 16px;
  }

  .categories-details {
    width: 70%;

    -webkit-overflow-scrolling: touch;

    @include media (tablet) {
      scroll-snap-type: x mandatory;
      overflow-x: auto;
      display: flex;
      width: 100%;
      box-sizing: border-box;
      padding: 0 calc(50% - 200px);
    }

    @include media (phone) {
      padding: 0 calc(50% - 100px);
    }

    .fake-categorie {
      width: 100px;
      height: 20px;
      flex-shrink: 0;
      display: none;

      @include media(tablet) {
        display: block;
      }

    }

    .categories-detail {
      display: flex;
      justify-content: center;

      background-attachment: red;

      align-items: center;
      background-color: #FFFFFF;
      border: 4px solid #B98A30;
      border-radius: 4px;
      box-shadow: 0 2px 9px 0 rgba(124,124,124,0.5);
      color: #979797;
      cursor: pointer;
      display: flex;
      filter: grayscale(1);
      width: 384px;
      height: 68px;
      margin-bottom: 20px;

      margin-bottom: 20px;
      user-select: none;

      transition: color .3s ease;

      @include media (tablet) {
        scroll-snap-align: center;
        flex-shrink: 0;
        width: 400px;
        margin-right: 20px;
        margin-bottom: unset;
      }

      @include media (phone) {
        width: 250px;
        margin-bottom: unset;
      }

      .triangle-container {
        content: '';
        background-color: #B98A30;
        position: absolute;

        transition: all .3s ease;

        right: 10px;
        height: 32px;
        width: 32px;
        border-radius: 2px;
        transform: rotate(45deg);

        transition: right .3s ease;

        @include media(phone) {
          display: none;
        }

        &.open {
          right: -17px;
        }
      }

      &.isActive {
        color: #494949;
        filter: grayscale(0);

        @include media (tablet) {
          overflow: hidden;
        }
      }

      .categories-container {
        display: flex;
        align-items: center;
        justify-content: flex-start;
        width: 100%;
        height: 100%;

        z-index: 1;
        background: #f1f1f1;

        .categories-logo {
          height: 50px;
          width: 50px;
          margin: 0 22px;
        }
        .spacer {
          width: 1px;
          height: 65%;
          background: #979797;
        }

        .categories-name {
          font-size: 1.5rem;
          font-weight: 900;
          white-space: nowrap;
          flex-grow: 1;
          text-align: center;
        }
      }
    }
  }
}
</style>
